import { render } from "./GroupEditPopup.vue?vue&type=template&id=3fe5da25&scoped=true&ts=true"
import script from "./GroupEditPopup.vue?vue&type=script&lang=ts"
export * from "./GroupEditPopup.vue?vue&type=script&lang=ts"

import "./GroupEditPopup.vue?vue&type=style&index=0&id=3fe5da25&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe5da25"]])

export default __exports__